import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const UbsHealthSchema = z.union([
  z.literal('OK'),
  z.object({
    success: z.literal(false),
    error: z.string(),
    message: z.string(),
  }),
])

export type UbsHealth = ZodInfer<typeof UbsHealthSchema>
